const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class NationalPride extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.NationalPride,
            "The civilization with the most culture points scores 5 culture.",
            {}
        )
    }
}

module.exports = NationalPride;